module.exports = __webpack_public_path__ + "files/65bb999242b7e0148765c619944cbd22.png";